module.exports = __webpack_public_path__ + "img/generic-certificate.dbd271b8.svg";